import { overlay } from 'overlay-kit';
import {CommonModal} from "../components/modal/CommonModal";

export const showModal = (modalProps) => {
    return new Promise((resolve, reject) => {
        overlay.open(({ isOpen, close }) => (
            <CommonModal
                open={isOpen}
                onClose={() => {
                    close();
                }}
                {...modalProps}
                onConfirm={() => {
                    modalProps.onConfirm?.();
                    resolve(true);
                }}
            />
        ));
    });
};